import React, { memo, Fragment, useContext, useState } from 'react'
import { Image } from 'react-bootstrap'
import { AuthContext } from '../../context/auth-context'
import { gql, useQuery } from '@apollo/client'
import { CubeLoader } from '@/components/ui/cube-loader'
import Loader from './Loader'

const GET_USER = gql`
    query Users($where: UserWhere) {
        users(where: $where) {
            id
            email
            firstName
            lastName
            logoImage
        }
    }
`

const DEFAULT_PROFILE_IMAGE = 'logo-dark.png'

const SidebarProfileCard = memo(() => {
    const { user } = useContext(AuthContext)

    const { data, loading } = useQuery(GET_USER, {
        variables: { where: { id: user.id } },
        onCompleted: (data) => {
            if (data?.users[0]?.logoImage) {
                setProfileImage(data.users[0].logoImage)
            }
        },
    })
    const [profileImage, setProfileImage] = useState(data?.users[0]?.logoImage || DEFAULT_PROFILE_IMAGE)

    const name = () => {
        return data?.users[0]?.firstName + ' ' + data?.users[0]?.lastName
    }

    if (loading) {
        return (
            <div>
                <Loader height="100px" />
            </div>
        )
    }

    return (
        <Fragment>
            <div className="sidebar-profile-card">
                <div className="sidebar-profile-body">
                    <div className="sidebar-profile-avatar d-flex justify-content-center pe-3 ps-0">
                        <Image
                            src={`${import.meta.env.VITE_S3_BUCKET_URL || ''}${profileImage ? profileImage : DEFAULT_PROFILE_IMAGE}`}
                            alt="User Logo"
                            onError={() => setProfileImage(DEFAULT_PROFILE_IMAGE)}
                            className="img-fluid rounded"
                        />
                    </div>
                    <div className="sidebar-profile-detail">
                        <h6 className="sidebar-profile-name">{name()}</h6>
                    </div>
                </div>
            </div>
        </Fragment>
    )
})

export default SidebarProfileCard
